import isEqual from "react-fast-compare";

export const removeMatchingObjects = (list1, list2) => {
  return list1.filter((obj1) => {
    return !list2.some((obj2) => {
      return isEqual(obj1, obj2);
    });
  });
};
